import * as React from "react"
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import HeroCover from "../components/HeroCover/HeroCover"
import styled from "styled-components"
import ContactCard from '../components/ContactCard/ContactCard'
import parse from "html-react-parser"

const DirectionBoxHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  
  padding: 0 60px;
  border-bottom: 1px solid #e0e0e0;;
  cursor: pointer;
  
  @media (max-width: 600px) {
    padding: 16px;
  }

  & p {
    font-weight: 700;
    margin-left: 50px;
  }
`

const DirectionBoxContent = styled.div`
  padding: ${({ open }) => open ? "20px 60px" : "0px"};

  & div {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 600px) {
    padding: ${({ open }) => open ? "16px" : "0px"};
  }
`

export const DirectionBox = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-bottom: 36px;
`

const ContactsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`

const AboutPage = ({ data }) => {
  const dataSet = data.allPrismicAboutPage.edges[0].node.data
  const { title, description, backround_image, directions, contacts } = dataSet

  const renderContacts = (contacts) => {
    return contacts.map((contact) => {
      const { network, person, number } = contact.contact.document.data
      return(
        <ContactCard
          network={network.text}
          person={person.text}
          number={number.text}
        />
      )
    })
  }

  const DirectionsContainer = ({ directions }) => {

    return(
      <div>
        {directions.map(directionItem => {
          const { mode_of_transportation, description } = directionItem.direction.document.data
          return(
            <DirectionItem
              mode_of_transportation={mode_of_transportation.text}
              description={description.html}
            />
          )
        })}
      </div>
    )
  }

  const DirectionItem = ({ mode_of_transportation, description }) => {

    const [open, setOpen] = React.useState(false)
  
    return(
      <DirectionBox>
        <DirectionBoxHeader onClick={() => setOpen(!open)}>
          <h4>{mode_of_transportation}</h4>
          <p>[{open ? "-" : "+"}] </p>
        </DirectionBoxHeader>
        <DirectionBoxContent open={open}>
          {
            open
            ?
            <div>
              <p>{parse(description)}</p>
            </div>
            :
            null
          }
        </DirectionBoxContent>
      </DirectionBox>
    )
  }

  return (
    <Layout>
      <HeroCover
        title={title.text}
        description={description.text}
        image={backround_image.url}
      />
      <div className="headings">
        <h2>Location</h2>
        <p>Find Mangkalalot Trek N' Brew using this pinned location on Google Maps</p>
      </div>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4729.902073358362!2d125.17541602014802!3d8.228528643369373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwMTMnNDMuOCJOIDEyNcKwMTAnMzkuMyJF!5e0!3m2!1sen!2sph!4v1628848364328!5m2!1sen!2sph" width="100%" height="450" allowfullscreen="" loading="lazy"></iframe>
      <hr />
      <div className="headings">
        <h2>Directions</h2>
        <p>Looking forward to travelling here at Mangkalalot? Identify your mode of transportation go through the directions</p>
      </div>
      <DirectionsContainer directions={directions} />
      <hr />
      <div className="headings">
        <h2>Contacts</h2>
        <p>If you have further inquiries regarding Mangkalalot Trek N' Brew, feel free to contact us through the different options below</p>
      </div>
      <ContactsContainer>
        {renderContacts(contacts)}
      </ContactsContainer>
      <div className="socMed">
        <hr />
        <div className="headings">
          <h2>Facebook Posts</h2>
          <p>View our posts from our Facebook Page</p>
        </div>
        <div className="fbPosts">
          <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ftreknbrew%2F&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
        </div>
      </div>
    </Layout>  
  )
}

export const query = graphql`
  {
    allPrismicAboutPage {
      edges {
        node {
          data {
            title {
              text
            }
            backround_image {
              url
            }
            directions {
              direction {
                document {
                  ... on PrismicDirections {
                    id
                    data {
                      mode_of_transportation {
                        text
                      }
                      description {
                        html
                      }
                    }
                  }
                }
              }
            }
            description {
              text
            }
            contacts {
              contact {
                document {
                  ... on PrismicContacts {
                    id
                    data {
                      person {
                        text
                      }
                      number {
                        text
                      }
                      network {
                        text
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default AboutPage
